import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  rootError: {
    "& $wrap": {
      border: `1px dashed ${theme.palette.error.main}`,
    },
  },
  wrap: {
    position: "relative",
    height: 90,
    padding: 20,
    border: `1px dashed ${theme.palette.grey[300]}`,
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
  },
  empty: {
    position: "relative",
    cursor: "pointer",
  },
  emptyIconWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 8,
  },
  emptyIcon: {
    color: theme.palette.grey[600],
  },
  text: {
    fontSize: 12,
    lineHeight: "16px",
    color: theme.palette.grey[700],
    textAlign: "center",
  },
  filled: {
    position: "relative",
  },
  imageWrap: {
    position: "relative",
    height: "100%",
  },
  image: {
    position: "absolute",
    inset: 0,
    maxWidth: "140px",
    maxHeight: "60px",
    margin: "auto",
  },
  deleteButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 12,
    left: 12,
    width: 24,
    height: 24,
    background: "transparent",
    border: 0,
    cursor: "pointer",
  },
  editButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 12,
    right: 12,
    width: 24,
    height: 24,
    background: "transparent",
    border: 0,
    cursor: "pointer",
  },
  icon: {
    width: 16,
    height: 16,
    fill: theme.palette.grey[600],
  },
}));
